import { defineComponent as _defineComponent } from 'vue'
import store from '@/store';
import { LevelFilter, MultiSelectOption, WorkScheduleActions, WorkScheduleGetters } from '@/types';
import { FilterIcon } from '@heroicons/vue/solid';
import { computed, Ref, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'WorkScheduleListFilters',
  setup(__props, { expose: __expose }) {
  __expose();

const { t } = useI18n();
const filterOpened = ref(false);
const defaultFilter = computed(() => store.getters[WorkScheduleGetters.DEFAULT_FILTER]);
const filter: Ref<LevelFilter> = ref({
    isActive: defaultFilter.value.isActive,
});
const storeFilters = computed<LevelFilter>(() => store.getters[WorkScheduleGetters.FILTER]);
const isActiveFilterOptions = [
    {
        label: t('workSchedule.filters.isActive.options.active'),
        value: true,
    },
    {
        label: t('workSchedule.filters.isActive.options.inactive'),
        value: false,
    },
] as MultiSelectOption[];

const applyFilters = () => {
    store.dispatch(WorkScheduleActions.SET_FILTER, filter.value);
};

const clearFilters = () => {
    store.dispatch(WorkScheduleActions.CLEAR_FILTER);
    refreshLocalFilter();
};

const refreshLocalFilter = () => {
    filter.value.isActive = storeFilters.value.isActive;
};

watch(filterOpened, () => {
    refreshLocalFilter();
});

const __returned__ = { t, filterOpened, defaultFilter, filter, storeFilters, isActiveFilterOptions, applyFilters, clearFilters, refreshLocalFilter, get FilterIcon() { return FilterIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})